import { render, staticRenderFns } from "./receipt_detail_with.vue?vue&type=template&id=7b974cf1&scoped=true&"
import script from "./receipt_detail_with.vue?vue&type=script&lang=js&"
export * from "./receipt_detail_with.vue?vue&type=script&lang=js&"
import style0 from "./receipt_detail_with.vue?vue&type=style&index=0&id=7b974cf1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b974cf1",
  null
  
)

export default component.exports